import { Button, ButtonProps, CircularProgress } from "@mui/material"
import { PropsWithChildren } from "react"

interface KaziButtonProps extends ButtonProps, PropsWithChildren {
    loading?: {
        isLoading: boolean;
        loadingText: string;
        color?: "secondary" | "primary" | "error" | "inherit" | "success" | "warning" | "info";
    }
    text: string;
}
export const KaziButton = (props: KaziButtonProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const isLoading = props?.loading?.isLoading;
    const loadingText = props?.loading?.loadingText;
    const loadingColor = props?.loading?.color;
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Button
            {...props}
            endIcon={ isLoading && <CircularProgress color={loadingColor ? loadingColor : "primary"} size={"18px"}/>}
        >
            {isLoading ? loadingText : props.text}
        </Button>
    )
}